export const SCANNER_GUIDE_SECTIONS = [
  { id: "scanner-overview", title: "What each scanner does" },
  { id: "when-to-use", title: "When to use each scanner" },
  { id: "opportunity-score", title: "Opportunity Score" },
  { id: "ai-confidence", title: "AI Confidence" },
  { id: "simulated-setups", title: "Example simulated trade setups" },
  { id: "best-practices", title: "Best Practices" },
  { id: "common-mistakes", title: "Common Mistakes" },
  { id: "future-learning", title: "Future Learning" },
];

export const SCANNER_SUMMARIES = [
  {
    name: "Day Trading Scanner",
    description:
      "Highlights simulated intraday momentum, liquidity, price action, and short-term setup alignment.",
    whenToUse:
      "Use during an active demo session to review short-duration setups that need prompt confirmation and defined risk.",
  },
  {
    name: "Premarket Scanner",
    description:
      "Surfaces simulated premarket gaps, volume expansion, catalysts, and levels before the regular session.",
    whenToUse:
      "Use before the simulated opening bell to build a focused plan, then re-check liquidity and confirmation after the open.",
  },
  {
    name: "Swing Opportunity Scanner",
    description:
      "Reviews simulated multi-session trends, relative strength, structure, and risk/reward alignment.",
    whenToUse:
      "Use when planning positions intended for several sessions rather than reacting to intraday movement.",
  },
  {
    name: "Options Opportunity Engine",
    description:
      "Reviews simulated bullish and bearish calls, puts, and defined-risk spread candidates using options-specific filters.",
    whenToUse:
      "Use when a directional thesis is already defined and contract liquidity, expiration, delta, and premium risk require review.",
  },
];

export const OPPORTUNITY_SCORE_EXAMPLE = [
  { label: "Volume", points: 18, explanation: "Strong simulated participation" },
  { label: "Relative Strength", points: 17, explanation: "Outperforming demo benchmark" },
  { label: "Trend", points: 19, explanation: "Aligned multi-timeframe structure" },
  { label: "Volatility", points: 14, explanation: "Active but manageable demo range" },
  { label: "Price Action", points: 16, explanation: "Constructive simulated breakout" },
];

export const CONFIDENCE_LEVELS = [
  {
    label: "High Confidence",
    range: "80–100",
    description: "Many informational factors align in the simulated review.",
  },
  {
    label: "Medium Confidence",
    range: "60–79",
    description: "Some factors align, while meaningful uncertainties remain.",
  },
  {
    label: "Low Confidence",
    range: "0–59",
    description: "Evidence is limited, mixed, or does not support a clear review.",
  },
];

export const SIMULATED_SETUPS = [
  {
    type: "Day Trade",
    symbol: "NVDA",
    setup: "Opening-range continuation",
    trigger: "Demo break above $181.20",
    risk: "Demo stop below $179.80",
    focus: "Volume confirmation; avoid chasing",
  },
  {
    type: "Premarket",
    symbol: "PLTR",
    setup: "Gap-and-hold review",
    trigger: "Demo hold above $154.00",
    risk: "Demo invalidation below $152.90",
    focus: "Opening liquidity and spread",
  },
  {
    type: "Swing",
    symbol: "AAPL",
    setup: "Multi-session trend pullback",
    trigger: "Demo reclaim of $234.50",
    risk: "Demo stop below structure",
    focus: "Trend, market regime, risk/reward",
  },
  {
    type: "Options",
    symbol: "QQQ",
    setup: "Bull call spread review",
    trigger: "Demo confirmation above resistance",
    risk: "Demo premium capped at spread debit",
    focus: "Liquidity, expiration, delta, IV",
  },
];

export const BEST_PRACTICES = [
  "Wait for confirmation before treating a setup as actionable.",
  "Respect predefined stop-loss and invalidation levels.",
  "Avoid chasing price after the planned entry area has passed.",
  "Review broader market conditions and liquidity.",
];

export const COMMON_MISTAKES = [
  "Trading illiquid stocks or contracts with wide spreads.",
  "Ignoring the dominant trend or market regime.",
  "Overtrading after the highest-quality setups are gone.",
  "Trading without a defined risk-management plan.",
];

export const FUTURE_LEARNING = [
  "Video tutorials",
  "Interactive walkthroughs",
  "Scanner Academy lessons",
];
